(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7604],{

/***/ 29002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/simi.d1222001.svg","height":18,"width":18});

/***/ }),

/***/ 12936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61090);
/* harmony import */ var _breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _store_slices_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64975);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






var ProductDetailsBreadcrumbs = function() {
    var ref, ref1;
    var productState = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_slices_product__WEBPACK_IMPORTED_MODULE_2__/* .selectProduct */ .Fn);
    var category = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref1;
        return ((ref = productState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
    }, [
        (ref = productState.data) === null || ref === void 0 ? void 0 : ref.categories
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().breadcrumb_main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container), " ", "container position-inherit"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row align-items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        className: (_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().breadcrumb_container),
                        "aria-label": "breadcrumb",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/",
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().separator),
                                children: ">"
                            }),
                            category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/jewellery/category/".concat(category.slug),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: category.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().separator),
                                        children: ">"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_breadcrumb_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active),
                                children: (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.title
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductDetailsBreadcrumbs);


/***/ }),

/***/ 73424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/store/slices/product.ts
var product = __webpack_require__(64975);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./src/components/product-details/slider/slider.module.scss
var slider_module = __webpack_require__(41588);
var slider_module_default = /*#__PURE__*/__webpack_require__.n(slider_module);
// EXTERNAL MODULE: ./src/lib/ga4.ts
var ga4 = __webpack_require__(77981);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 68 modules
var esm = __webpack_require__(1485);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/Image.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Image = function Image(_ref) {
  var src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      imgAttributes = _ref.imgAttributes,
      isZoomed = _ref.isZoomed,
      fadeDuration = _ref.fadeDuration;
  var createSpacer = width && height && hasSpacer;
  return /*#__PURE__*/react.createElement("div", {
    style: {
      paddingTop: createSpacer ? height / width * 100 + "%" : null
    }
  }, sources && sources.length > 0 ? /*#__PURE__*/react.createElement("picture", null, sources.map(function (source, i) {
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: i
    }, source.srcSet && /*#__PURE__*/react.createElement("source", source));
  }), /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  }))) : /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  })));
};

Image.propTypes =  false ? 0 : {};
/* harmony default export */ var components_Image = (Image);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/ZoomImage.js



var ZoomImage = function ZoomImage(_ref) {
  var src = _ref.src,
      fadeDuration = _ref.fadeDuration,
      top = _ref.top,
      left = _ref.left,
      isZoomed = _ref.isZoomed,
      onLoad = _ref.onLoad,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onClose = _ref.onClose,
      onFadeOut = _ref.onFadeOut;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("img", {
    className: "iiz__zoom-img " + (isZoomed ? 'iiz__zoom-img--visible' : ''),
    style: {
      top: top,
      left: left,
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    src: src,
    onLoad: onLoad,
    onTouchStart: onDragStart,
    onTouchEnd: onDragEnd,
    onMouseDown: onDragStart,
    onMouseUp: onDragEnd,
    onTransitionEnd: onFadeOut,
    draggable: "false",
    alt: ""
  }), onClose && /*#__PURE__*/react.createElement("button", {
    className: "iiz__btn iiz__close " + (isZoomed ? 'iiz__close--visible' : ''),
    style: {
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    onClick: onClose,
    "aria-label": "Zoom Out"
  }));
};

ZoomImage.propTypes =  false ? 0 : {};
/* harmony default export */ var components_ZoomImage = (ZoomImage);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/FullscreenPortal.js




var FullscreenPortal = function FullscreenPortal(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(function () {
    var el = document.createElement('div');
    el.classList.add('iiz__zoom-portal');
    return el;
  }),
      portal = _useState[0];

  (0,react.useEffect)(function () {
    document.body.appendChild(portal);
    return function () {
      return document.body.removeChild(portal);
    };
  }, [portal]);
  return (0,react_dom.createPortal)(children, portal);
};

FullscreenPortal.propTypes = {
  children: (prop_types_default()).element
};
/* harmony default export */ var components_FullscreenPortal = (FullscreenPortal);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/InnerImageZoom.js
var _this = undefined;







var InnerImageZoom = function InnerImageZoom(_ref) {
  var _ref$moveType = _ref.moveType,
      moveType = _ref$moveType === void 0 ? 'pan' : _ref$moveType,
      _ref$zoomType = _ref.zoomType,
      zoomType = _ref$zoomType === void 0 ? 'click' : _ref$zoomType,
      src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      _ref$imgAttributes = _ref.imgAttributes,
      imgAttributes = _ref$imgAttributes === void 0 ? {} : _ref$imgAttributes,
      zoomSrc = _ref.zoomSrc,
      _ref$zoomScale = _ref.zoomScale,
      zoomScale = _ref$zoomScale === void 0 ? 1 : _ref$zoomScale,
      zoomPreload = _ref.zoomPreload,
      _ref$fadeDuration = _ref.fadeDuration,
      fadeDuration = _ref$fadeDuration === void 0 ? 150 : _ref$fadeDuration,
      fullscreenOnMobile = _ref.fullscreenOnMobile,
      _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? 640 : _ref$mobileBreakpoint,
      hideCloseButton = _ref.hideCloseButton,
      hideHint = _ref.hideHint,
      className = _ref.className,
      afterZoomIn = _ref.afterZoomIn,
      afterZoomOut = _ref.afterZoomOut;
  var img = (0,react.useRef)(null);
  var zoomImg = (0,react.useRef)(null);
  var imgProps = (0,react.useRef)({});

  var _useState = (0,react.useState)(zoomPreload),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTouch = _useState2[0],
      setIsTouch = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isZoomed = _useState3[0],
      setIsZoomed = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isFullscreen = _useState4[0],
      setIsFullscreen = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isDragging = _useState5[0],
      setIsDragging = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isValidDrag = _useState6[0],
      setIsValidDrag = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isFading = _useState7[0],
      setIsFading = _useState7[1];

  var _useState8 = (0,react.useState)(moveType),
      currentMoveType = _useState8[0],
      setCurrentMoveType = _useState8[1];

  var _useState9 = (0,react.useState)(0),
      left = _useState9[0],
      setLeft = _useState9[1];

  var _useState10 = (0,react.useState)(0),
      top = _useState10[0],
      setTop = _useState10[1];

  var handleMouseEnter = function handleMouseEnter(e) {
    setIsActive(true);
    setIsFading(false);
    zoomType === 'hover' && !isZoomed && handleClick(e);
  };

  var handleTouchStart = function handleTouchStart() {
    setIsTouch(true);
    setIsFullscreen(getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint));
    setCurrentMoveType('drag');
  };

  var handleClick = function handleClick(e) {
    if (isZoomed) {
      if (isTouch) {
        hideCloseButton && handleClose(e);
      } else {
        !isValidDrag && zoomOut();
      }

      return;
    }

    isTouch && setIsActive(true);

    if (zoomImg.current) {
      handleLoad({
        target: zoomImg.current
      });
      zoomIn(e.pageX, e.pageY);
    } else {
      imgProps.current.onLoadCallback = zoomIn.bind(_this, e.pageX, e.pageY);
    }
  };

  var handleLoad = function handleLoad(e) {
    var scaledDimensions = getScaledDimensions(e.target, zoomScale);
    zoomImg.current = e.target;
    zoomImg.current.setAttribute('width', scaledDimensions.width);
    zoomImg.current.setAttribute('height', scaledDimensions.height);
    imgProps.current.scaledDimensions = scaledDimensions;
    imgProps.current.bounds = getBounds(img.current, false);
    imgProps.current.ratios = getRatios(imgProps.current.bounds, scaledDimensions);

    if (imgProps.current.onLoadCallback) {
      imgProps.current.onLoadCallback();
      imgProps.current.onLoadCallback = null;
    }
  };

  var handleMouseMove = function handleMouseMove(e) {
    var left = e.pageX - imgProps.current.offsets.x;
    var top = e.pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, imgProps.current.bounds.width), 0);
    top = Math.max(Math.min(top, imgProps.current.bounds.height), 0);
    setLeft(left * -imgProps.current.ratios.x);
    setTop(top * -imgProps.current.ratios.y);
  };

  var handleDragStart = function handleDragStart(e) {
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    imgProps.current.offsets = getOffsets(pageX, pageY, zoomImg.current.offsetLeft, zoomImg.current.offsetTop);
    setIsDragging(true);

    if (!isTouch) {
      imgProps.current.eventPosition = {
        x: e.pageX,
        y: e.pageY
      };
    }
  };

  var handleDragMove = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    var left = pageX - imgProps.current.offsets.x;
    var top = pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, 0), (imgProps.current.scaledDimensions.width - imgProps.current.bounds.width) * -1);
    top = Math.max(Math.min(top, 0), (imgProps.current.scaledDimensions.height - imgProps.current.bounds.height) * -1);
    setLeft(left);
    setTop(top);
  }, []);

  var handleDragEnd = function handleDragEnd(e) {
    setIsDragging(false);

    if (!isTouch) {
      var moveX = Math.abs(e.pageX - imgProps.current.eventPosition.x);
      var moveY = Math.abs(e.pageY - imgProps.current.eventPosition.y);
      setIsValidDrag(moveX > 5 || moveY > 5);
    }
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    currentMoveType === 'drag' && isZoomed ? handleDragEnd(e) : handleClose(e);
  };

  var handleClose = function handleClose(e) {
    if (!(!isTouch && e.target.classList.contains('iiz__close'))) {
      if (!isZoomed || isFullscreen || !fadeDuration) {
        handleFadeOut({}, true);
      } else {
        setIsFading(true);
      }
    }

    zoomOut();
  };

  var handleFadeOut = function handleFadeOut(e, noTransition) {
    if (noTransition || e.propertyName === 'opacity' && img.current.contains(e.target)) {
      if (zoomPreload && isTouch || !zoomPreload) {
        zoomImg.current = null;
        imgProps.current = getDefaults();
        setIsActive(false);
      }

      setIsTouch(false);
      setIsFullscreen(false);
      setCurrentMoveType(moveType);
      setIsFading(false);
    }
  };

  var initialMove = function initialMove(pageX, pageY) {
    imgProps.current.offsets = getOffsets(window.pageXOffset, window.pageYOffset, -imgProps.current.bounds.left, -imgProps.current.bounds.top);
    handleMouseMove({
      pageX: pageX,
      pageY: pageY
    });
  };

  var initialDrag = function initialDrag(pageX, pageY) {
    var initialPageX = (pageX - (window.pageXOffset + imgProps.current.bounds.left)) * -imgProps.current.ratios.x;
    var initialPageY = (pageY - (window.pageYOffset + imgProps.current.bounds.top)) * -imgProps.current.ratios.y;
    initialPageX = initialPageX + (isFullscreen ? (window.innerWidth - imgProps.current.bounds.width) / 2 : 0);
    initialPageY = initialPageY + (isFullscreen ? (window.innerHeight - imgProps.current.bounds.height) / 2 : 0);
    imgProps.current.bounds = getBounds(img.current, isFullscreen);
    imgProps.current.offsets = getOffsets(0, 0, 0, 0);
    handleDragMove({
      changedTouches: [{
        pageX: initialPageX,
        pageY: initialPageY
      }],
      preventDefault: function preventDefault() {},
      stopPropagation: function stopPropagation() {}
    });
  };

  var zoomIn = function zoomIn(pageX, pageY) {
    setIsZoomed(true);
    currentMoveType === 'drag' ? initialDrag(pageX, pageY) : initialMove(pageX, pageY);
    afterZoomIn && afterZoomIn();
  };

  var zoomOut = function zoomOut() {
    setIsZoomed(false);
    afterZoomOut && afterZoomOut();
  };

  var getDefaults = function getDefaults() {
    return {
      onLoadCallback: null,
      bounds: {},
      offsets: {},
      ratios: {},
      eventPosition: {},
      scaledDimensions: {}
    };
  };

  var getBounds = function getBounds(img, isFullscreen) {
    if (isFullscreen) {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
        left: 0,
        top: 0
      };
    }

    return img.getBoundingClientRect();
  };

  var getOffsets = function getOffsets(pageX, pageY, left, top) {
    return {
      x: pageX - left,
      y: pageY - top
    };
  };

  var getRatios = function getRatios(bounds, dimensions) {
    return {
      x: (dimensions.width - bounds.width) / bounds.width,
      y: (dimensions.height - bounds.height) / bounds.height
    };
  };

  var getFullscreenStatus = function getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) {
    return fullscreenOnMobile && window.matchMedia && window.matchMedia("(max-width: " + mobileBreakpoint + "px)").matches;
  };

  var getScaledDimensions = function getScaledDimensions(zoomImg, zoomScale) {
    return {
      width: zoomImg.naturalWidth * zoomScale,
      height: zoomImg.naturalHeight * zoomScale
    };
  };

  var zoomImageProps = {
    src: zoomSrc || src,
    fadeDuration: isFullscreen ? 0 : fadeDuration,
    top: top,
    left: left,
    isZoomed: isZoomed,
    onLoad: handleLoad,
    onDragStart: currentMoveType === 'drag' ? handleDragStart : null,
    onDragEnd: currentMoveType === 'drag' ? handleDragEnd : null,
    onClose: !hideCloseButton && currentMoveType === 'drag' ? handleClose : null,
    onFadeOut: isFading ? handleFadeOut : null
  };
  (0,react.useEffect)(function () {
    imgProps.current = getDefaults();
  }, []);
  (0,react.useEffect)(function () {
    getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) && setIsActive(false);
  }, [fullscreenOnMobile, mobileBreakpoint]);
  (0,react.useEffect)(function () {
    if (!zoomImg.current) {
      return;
    }

    var eventType = isTouch ? 'touchmove' : 'mousemove';

    if (isDragging) {
      zoomImg.current.addEventListener(eventType, handleDragMove, {
        passive: true
      });
    } else {
      zoomImg.current.removeEventListener(eventType, handleDragMove);
    }
  }, [isDragging, isTouch, handleDragMove]);
  return /*#__PURE__*/react.createElement("figure", {
    className: "iiz " + (currentMoveType === 'drag' ? 'iiz--drag' : '') + " " + (className ? className : ''),
    style: {
      width: width
    },
    ref: img,
    onTouchStart: isZoomed ? null : handleTouchStart,
    onClick: handleClick,
    onMouseEnter: isTouch ? null : handleMouseEnter,
    onMouseMove: currentMoveType === 'drag' || !isZoomed ? null : handleMouseMove,
    onMouseLeave: isTouch ? null : handleMouseLeave
  }, /*#__PURE__*/react.createElement(components_Image, {
    src: src,
    sources: sources,
    width: width,
    height: height,
    hasSpacer: hasSpacer,
    imgAttributes: imgAttributes,
    fadeDuration: fadeDuration,
    isZoomed: isZoomed
  }), isActive && /*#__PURE__*/react.createElement(react.Fragment, null, isFullscreen ? /*#__PURE__*/react.createElement(components_FullscreenPortal, null, /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)) : /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)), !hideHint && !isZoomed && /*#__PURE__*/react.createElement("span", {
    className: "iiz__btn iiz__hint"
  }));
};

InnerImageZoom.propTypes =  false ? 0 : {};
/* harmony default export */ var InnerImageZoom_InnerImageZoom = (InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/index.js

/* harmony default export */ var es_InnerImageZoom = (InnerImageZoom_InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/index.js

/* harmony default export */ var react_inner_image_zoom_es = (es_InnerImageZoom);

// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/ppixel.ts
var ppixel = __webpack_require__(55763);
// EXTERNAL MODULE: ./src/lib/syte.ts
var syte = __webpack_require__(68320);
// EXTERNAL MODULE: ./src/image-loaders/s3-image-loader.ts
var s3_image_loader = __webpack_require__(78513);
;// CONCATENATED MODULE: ./src/components/react-zoom-slide/SliderImage.tsx
/* eslint-disable @next/next/no-img-element */ 

var cx = 0;
var cy = 0;
var lensCurrent = null;
var imageCurrent = null;
var resultCurrent = null;
var SilderImage = function(param) {
    var data = param.data, _width = param.width, width = _width === void 0 ? "auto" : _width, _showDescription = param.showDescription, showDescription = _showDescription === void 0 ? true : _showDescription, _direction = param.direction, direction = _direction === void 0 ? "right" : _direction;
    var getCursorPos = function getCursorPos(e, imageCurrent) {
        var x = 0;
        var y = 0;
        var getBoundingImage = imageCurrent.getBoundingClientRect();
        e = e || window.event;
        x = e.pageX - getBoundingImage.left - window.pageXOffset;
        y = e.pageY - getBoundingImage.top - window.pageYOffset;
        return {
            x: x,
            y: y
        };
    };
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    var selectedImage = data[index];
    var refImage = (0,react.useRef)(null);
    var refLens = (0,react.useRef)(null);
    var refResult = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(true), videoLoading = ref1[0], setVideoLoading = ref1[1];
    var videoRefs = (0,react.useRef)({});
    (0,react.useEffect)(function() {
        var moveLens = function moveLens(e, imageWidth, imageHeight, offsetWidthLens, offsetHeightLens) {
            e.preventDefault();
            var x = 0;
            var y = 0;
            var pos = getCursorPos(e, imageCurrent);
            x = pos.x - offsetWidthLens / 2;
            y = pos.y - offsetHeightLens / 2;
            if (x > imageWidth - offsetWidthLens) {
                x = imageWidth - offsetWidthLens;
            }
            if (x < 0) {
                x = 0;
            }
            if (y > imageHeight - offsetHeightLens) {
                y = imageHeight - offsetHeightLens;
            }
            if (y < 0) {
                y = 0;
            }
            if (lensCurrent) {
                lensCurrent.style.left = "".concat(x, "px");
                lensCurrent.style.top = "".concat(y, "px");
            }
            if (resultCurrent) {
                resultCurrent.style.backgroundPosition = "-".concat(x * cx, "px -").concat(y * cy, "px");
            }
        };
        if (selectedImage.type !== "image") return;
        lensCurrent = refLens.current;
        imageCurrent = refImage.current;
        resultCurrent = refResult.current;
        var calculateZoomDimensions = function() {
            if (imageCurrent && lensCurrent && resultCurrent) {
                var imageWidth = imageCurrent.width;
                var imageHeight = imageCurrent.height || imageWidth - 120;
                var offsetWidthLens = lensCurrent.offsetWidth;
                var offsetHeightLens = lensCurrent.offsetHeight;
                cx = resultCurrent.offsetWidth / offsetWidthLens;
                cy = resultCurrent.offsetHeight / offsetHeightLens;
                resultCurrent.style.backgroundSize = "".concat(imageWidth * cx, "px ").concat(imageHeight * cy, "px");
                imageCurrent.addEventListener("mousemove", function(e) {
                    return moveLens(e, imageWidth, imageHeight, offsetWidthLens, offsetHeightLens);
                });
                lensCurrent.addEventListener("mousemove", function(e) {
                    return moveLens(e, imageWidth, imageHeight, offsetWidthLens, offsetHeightLens);
                });
            }
        };
        if (imageCurrent) {
            if (imageCurrent.complete) {
                calculateZoomDimensions();
            } else {
                imageCurrent.onload = function() {
                    calculateZoomDimensions();
                };
            }
        }
    }, [
        [
            selectedImage
        ]
    ]);
    var onPrevSlider = (0,react.useCallback)(function() {
        setIndex(function(prev) {
            return (prev - 1 + data.length) % data.length;
        });
    }, [
        data.length
    ]);
    var onNextSlider = (0,react.useCallback)(function() {
        setIndex(function(prev) {
            return (prev + 1) % data.length;
        });
    }, [
        data.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "react-slider",
        style: {
            width: width || "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "react-slider__container",
                children: [
                    selectedImage.type === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "react-slider__areaZoom",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "react-slider__lens",
                                        ref: refLens
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "react-slider__picture",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: selectedImage.image,
                                            alt: selectedImage.alt,
                                            ref: refImage
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: refResult,
                                        className: "react-slider__imgZoom",
                                        style: {
                                            backgroundImage: "url(".concat(selectedImage.image, ")"),
                                            left: "".concat(direction === "left" && "-107%")
                                        }
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "video-middle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                ref: function(el) {
                                    return videoRefs.current[index] = el;
                                },
                                src: selectedImage.image,
                                controls: true,
                                autoPlay: true,
                                muted: true,
                                playsInline: true,
                                loop: true,
                                style: {
                                    maxWidth: "100%",
                                    height: "auto",
                                    opacity: videoLoading ? 0.5 : 1
                                },
                                onCanPlayThrough: function(e) {
                                    e.currentTarget.style.background = "none";
                                },
                                onError: function(e) {
                                    e.currentTarget.poster = "/fallback.jpg";
                                },
                                onCanPlay: function() {
                                    return setVideoLoading(false);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "react-slider__btnPrev",
                        onClick: onPrevSlider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "react-slider__btnNext",
                        onClick: onNextSlider
                    }),
                    showDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "react-slider__description",
                        children: selectedImage.text
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "react-slider__ul",
                children: data.map(function(item, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: idx === index ? "active" : "",
                        onClick: function() {
                            setIndex(idx);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.type == "video" ? item.preview : item.image,
                            alt: item.alt
                        })
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var SliderImage = (SilderImage);

// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
// EXTERNAL MODULE: ./src/components/similar-product/similar-product.tsx + 3 modules
var similar_product = __webpack_require__(9556);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./src/components/product-details/slider/slider.tsx




































var ProductDetailsSlider = function() {
    var ref, ref1, ref2;
    swiper_esm/* default.use */.ZP.use([
        swiper_esm/* Navigation */.W_,
        swiper_esm/* FreeMode */.Rv,
        swiper_esm/* Thumbs */.o3
    ]);
    var productState = (0,es/* useSelector */.v9)(product/* selectProduct */.Fn);
    var width = (0,esm/* useWindowSize */.iP)().width;
    var ref3 = (0,react.useState)(null), thumbsSwiper = ref3[0], setThumbsSwiper = ref3[1];
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var ref4 = (0,react.useState)(false), tryOnAddToCart = ref4[0], setTryOnAddToCart = ref4[1];
    var ref5 = (0,react.useState)(false), tryOnRemoveFromCart = ref5[0], setTryOnRemoveFromCart = ref5[1];
    var ref6 = (0,react.useState)(true), videoLoading = ref6[0], setVideoLoading = ref6[1];
    var videoRefs = (0,react.useRef)({});
    var ref7 = (0,react.useState)(false), show = ref7[0], setShow = ref7[1];
    var ref8 = (0,react.useState)([]), skus = ref8[0], setskus = ref8[1];
    var ref9 = (0,react.useState)(false), similarLoading = ref9[0], setSimilarLoading = ref9[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(image) {
            var formdata, data, filteredImages, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSimilarLoading(true);
                        formdata = new FormData();
                        formdata.append("image_url", image);
                        formdata.append("tags", "[\"senco\"]" || 0);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return http_client/* default.post */.Z.post(endpoints/* default.products.similarproduct */.Z.products.similarproduct(), formdata);
                    case 7:
                        data = _ctx.sent.data;
                        filteredImages = data.images.filter(function(v) {
                            return v.distance > 0.65;
                        });
                        _ctx.next = 11;
                        return setskus(filteredImages.map(function(v) {
                            return v.product_id;
                        }));
                    case 11:
                        setShow(true);
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        (0,react_toastify_esm/* toast */.Am)(((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) || "No products found", {
                            type: "error",
                            toastId: "coupon-otp-error"
                        });
                    case 18:
                        _ctx.prev = 18;
                        setSimilarLoading(false);
                        return _ctx.finish(18);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    14,
                    18,
                    21
                ]
            ]);
        }));
        return function handleShow(image) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref10 = (0,react.useState)(false), isOpen = ref10[0], setIsOpen = ref10[1];
    var cartItem = (0,react.useMemo)(function() {
        return cartState.items.find(function(v) {
            var ref, ref1;
            return v.identifier == ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
        }) || null;
    }, [
        cartState.items,
        (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (authState.user) {
                            _ctx.next = 4;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.id
                        });
                    case 6:
                        if (window.Moengage) {
                            ;
                            window.Moengage.track_event("Added to Cart", {
                                name: (ref13 = productState.data) === null || ref13 === void 0 ? void 0 : ref13.title,
                                id: (ref14 = productState.data) === null || ref14 === void 0 ? void 0 : ref14.sku,
                                amount: ((ref15 = productState.selectedPrice) === null || ref15 === void 0 ? void 0 : ref15.discount) ? (ref16 = productState.selectedPrice) === null || ref16 === void 0 ? void 0 : ref16.discount.total : (ref17 = productState.selectedPrice) === null || ref17 === void 0 ? void 0 : ref17.total
                            });
                        }
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.id,
                            variant_id: (ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.id,
                            image_url: (ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.images[0].media,
                            prqt: 1,
                            product_name: (ref4 = productState.data) === null || ref4 === void 0 ? void 0 : ref4.title,
                            category: ((ref5 = productState.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.categories) === null || ref6 === void 0 ? void 0 : ref6.length) ? (ref7 = (0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0]) === null || ref7 === void 0 ? void 0 : ref7.name : "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: (ref8 = productState.selectedPrice) === null || ref8 === void 0 ? void 0 : ref8.total,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat((ref9 = productState.data) === null || ref9 === void 0 ? void 0 : ref9.slug),
                            discounted_price: ((ref10 = productState.selectedPrice) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.discount) === null || ref11 === void 0 ? void 0 : ref11.price) || 0,
                            stock_availability: ((ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.stock) ? 1 : 0
                        });
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: (ref18 = productState.selectedPrice) === null || ref18 === void 0 ? void 0 : ref18.id
                        });
                    case 12:
                        if (window.Moengage) {
                            ;
                            window.Moengage.track_event("Added to Cart", {
                                name: (ref30 = productState.data) === null || ref30 === void 0 ? void 0 : ref30.title,
                                id: (ref31 = productState.data) === null || ref31 === void 0 ? void 0 : ref31.sku,
                                amount: ((ref32 = productState.selectedPrice) === null || ref32 === void 0 ? void 0 : ref32.discount) ? (ref33 = productState.selectedPrice) === null || ref33 === void 0 ? void 0 : ref33.discount.total : (ref34 = productState.selectedPrice) === null || ref34 === void 0 ? void 0 : ref34.total
                            });
                        }
                        _ctx.next = 15;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 15:
                        (0,react_toastify_esm/* toast */.Am)("Item added in cart", {
                            type: "success",
                            toastId: "cart-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToCart", {
                            content_type: "product",
                            content_ids: [
                                (ref19 = productState.data) === null || ref19 === void 0 ? void 0 : ref19.sku
                            ]
                        });
                        (0,ppixel/* ptrackEvent */.rn)("addtocart", {
                            event_id: "atc_".concat(Date.now()),
                            value: ((ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.discount) ? (ref21 = productState.selectedPrice) === null || ref21 === void 0 ? void 0 : ref21.discount.total : (ref22 = productState.selectedPrice) === null || ref22 === void 0 ? void 0 : ref22.total,
                            order_quantity: 1,
                            currency: "INR"
                        });
                        if (((ref23 = productState.data) === null || ref23 === void 0 ? void 0 : ref23.categories) && ((ref24 = productState.data) === null || ref24 === void 0 ? void 0 : ref24.categories.length)) {
                            ;
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: ((ref35 = productState.selectedPrice) === null || ref35 === void 0 ? void 0 : ref35.discount) ? (ref36 = productState.selectedPrice) === null || ref36 === void 0 ? void 0 : ref36.discount.total : (ref37 = productState.selectedPrice) === null || ref37 === void 0 ? void 0 : ref37.total,
                                    items: [
                                        {
                                            item_id: (ref38 = productState.data) === null || ref38 === void 0 ? void 0 : ref38.sku,
                                            item_name: (ref39 = productState.data) === null || ref39 === void 0 ? void 0 : ref39.title,
                                            item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                            item_category: (0,_to_consumable_array/* default */.Z)((ref40 = productState.data) === null || ref40 === void 0 ? void 0 : ref40.categories).reverse()[0].name,
                                            item_variant: (ref41 = productState.selectedPrice) === null || ref41 === void 0 ? void 0 : ref41.purity,
                                            price: ((ref42 = productState.selectedPrice) === null || ref42 === void 0 ? void 0 : ref42.discount) ? (ref43 = productState.selectedPrice) === null || ref43 === void 0 ? void 0 : ref43.discount.total : (ref44 = productState.selectedPrice) === null || ref44 === void 0 ? void 0 : ref44.total,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        (0,syte/* syteTrackEvent */.l)({
                            name: "products_added_to_cart",
                            tag: "ecommerce",
                            osh_id: (ref25 = authState.user) === null || ref25 === void 0 ? void 0 : ref25.uuid,
                            products: [
                                {
                                    sku: (ref26 = productState.data) === null || ref26 === void 0 ? void 0 : ref26.sku,
                                    price: ((ref27 = productState.selectedPrice) === null || ref27 === void 0 ? void 0 : ref27.discount) ? (ref28 = productState.selectedPrice) === null || ref28 === void 0 ? void 0 : ref28.discount.total : (ref29 = productState.selectedPrice) === null || ref29 === void 0 ? void 0 : ref29.total,
                                    quantity: 1
                                }, 
                            ]
                        });
                        _ctx.next = 26;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](8);
                        ;
                        if (Number(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref45 = _ctx.t0.response) === null || ref45 === void 0 ? void 0 : ref45.status) === 400) {
                            (0,react_toastify_esm/* toast */.Am)("Something went wrong! Refreshing the page!", {
                                type: "error",
                                toastId: "refresh-error"
                            });
                            window.location.reload();
                        }
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    22
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tryOnAddToCart) {
            setTryOnAddToCart(false);
            addToCart();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnAddToCart
    ]);
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 3:
                        _ctx.next = 5;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 5:
                        if (window.Moengage) {
                            window.Moengage.track_event("Removed From Cart", {
                                name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.name,
                                id: cartItem === null || cartItem === void 0 ? void 0 : cartItem.slug,
                                amount: cartItem === null || cartItem === void 0 ? void 0 : cartItem.price
                            });
                        }
                        if (window.smartech) {
                            ;
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Remove from cart ", {
                                source: "web",
                                platform: "senco",
                                prid: (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.id,
                                variant_id: (ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.id,
                                image: (ref4 = productState.data) === null || ref4 === void 0 ? void 0 : ref4.images[0].media,
                                prqt: ((ref5 = productState.data) === null || ref5 === void 0 ? void 0 : ref5.stock) || 1,
                                product_name: (ref6 = productState.data) === null || ref6 === void 0 ? void 0 : ref6.title,
                                amount: (ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.total,
                                product_url: "".concat(window.location.origin, "/jewellery/").concat((ref8 = productState.data) === null || ref8 === void 0 ? void 0 : ref8.slug)
                            });
                        }
                        (0,react_toastify_esm/* toast */.Am)("Item removed from cart", {
                            type: "info",
                            toastId: "cart-remove-success"
                        });
                        if (((ref = productState.data) === null || ref === void 0 ? void 0 : ref.categories) && ((ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.categories.length)) {
                            ;
                            window.gtag("event", "remove_from_cart", {
                                currency: "INR",
                                value: ((ref9 = productState.selectedPrice) === null || ref9 === void 0 ? void 0 : ref9.discount) ? (ref10 = productState.selectedPrice) === null || ref10 === void 0 ? void 0 : ref10.discount.total : (ref11 = productState.selectedPrice) === null || ref11 === void 0 ? void 0 : ref11.total,
                                items: [
                                    {
                                        item_id: (ref12 = productState.data) === null || ref12 === void 0 ? void 0 : ref12.sku,
                                        item_name: (ref13 = productState.data) === null || ref13 === void 0 ? void 0 : ref13.title,
                                        item_category: (0,_to_consumable_array/* default */.Z)((ref14 = productState.data) === null || ref14 === void 0 ? void 0 : ref14.categories).reverse()[0].name,
                                        price: ((ref15 = productState.selectedPrice) === null || ref15 === void 0 ? void 0 : ref15.discount) ? (ref16 = productState.selectedPrice) === null || ref16 === void 0 ? void 0 : ref16.discount.total : (ref17 = productState.selectedPrice) === null || ref17 === void 0 ? void 0 : ref17.total,
                                        quantity: 1
                                    }, 
                                ]
                            });
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "remove_from_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: ((ref18 = productState.selectedPrice) === null || ref18 === void 0 ? void 0 : ref18.discount) ? (ref19 = productState.selectedPrice) === null || ref19 === void 0 ? void 0 : ref19.discount.total : (ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.total,
                                    items: [
                                        {
                                            item_id: (ref21 = productState.data) === null || ref21 === void 0 ? void 0 : ref21.sku,
                                            item_name: (ref22 = productState.data) === null || ref22 === void 0 ? void 0 : ref22.title,
                                            item_category: (0,_to_consumable_array/* default */.Z)((ref23 = productState.data) === null || ref23 === void 0 ? void 0 : ref23.categories).reverse()[0].name,
                                            price: ((ref24 = productState.selectedPrice) === null || ref24 === void 0 ? void 0 : ref24.discount) ? (ref25 = productState.selectedPrice) === null || ref25 === void 0 ? void 0 : ref25.discount.total : (ref26 = productState.selectedPrice) === null || ref26 === void 0 ? void 0 : ref26.total,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tryOnRemoveFromCart) {
            setTryOnRemoveFromCart(false);
            removeFromCart();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tryOnRemoveFromCart
    ]);
    var openTryOn = function() {
        if (window.initMirrarUI && productState.data && "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f") {
            (0,tryOnTracking/* initTryOnEventListener */.K)(function(name, data) {
                if (name == "add-to-cart") {
                    var ref;
                    if (data.productCode == ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.sku)) {
                        setTryOnAddToCart(true);
                    }
                }
                if (name == "ProductRemoveFromCart") {
                    var ref1;
                    if (data.productCode == ((ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.sku)) {
                        setTryOnRemoveFromCart(true);
                    }
                }
            });
            window.initMirrarUI(productState.data.sku, {
                brandId: "e517b5d3-15f1-4d2c-87a7-ecb16d0d151f"
            });
            if (productState.data.categories && productState.data.categories.length) {
                var ref;
                window.gtag("event", "tryon-button-click", {
                    event_category: "mirrar-internal-event",
                    event_label: "".concat((0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0].name, "/").concat(productState.data.sku, "/").concat((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.discount_total)
                });
            }
        }
    };
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product_slider_zoom_slide",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (slider_module_default()).product_slider,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (slider_module_default()).try_container,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                className: "".concat((slider_module_default()).try__on, " syte-discovery"),
                                "data-placement": "PDP-button",
                                onClick: function() {
                                    var ref, ref1;
                                    return handleShow((ref1 = (ref = productState.data) === null || ref === void 0 ? void 0 : ref.medias[0]) === null || ref1 === void 0 ? void 0 : ref1.media_url);
                                },
                                children: similarLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            size: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (slider_module_default()).v_t,
                                            children: "Loading.."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(29002),
                                            alt: "Similar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (slider_module_default()).v_t,
                                            children: "Similar"
                                        })
                                    ]
                                })
                            })
                        }),
                        width > 991 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: productState.data.images.length > 1 ? "" : "arrow_handle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImage, {
                                    data: (0,_to_consumable_array/* default */.Z)(productState.data.medias.map(function(item) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            preview: item.media_type == "video" ? "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/video-play-icon.png" : ""
                                        });
                                    })).map(function(v) {
                                        var ref;
                                        return {
                                            image: v.media_url,
                                            alt: ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.title) || "",
                                            type: v.media_type,
                                            preview: v.preview
                                        };
                                    }),
                                    showDescription: false,
                                    direction: "right"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    navigation: true,
                                    thumbs: {
                                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                                    },
                                    allowTouchMove: false,
                                    className: "mySwiper2",
                                    children: (0,_to_consumable_array/* default */.Z)(productState.data.medias.map(function(item) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            preview: item.media_type == "video" ? "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/video-play-icon.png" : ""
                                        });
                                    })).map(function(v, k) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: v.media_type == "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_inner_image_zoom_es, {
                                                src: (0,s3_image_loader/* S3ImageLoader */.V)({
                                                    src: v.media_url,
                                                    width: 800
                                                }),
                                                zoomSrc: v.media_url,
                                                zoomScale: 0.5,
                                                imgAttributes: {
                                                    alt: "".concat((ref = productState.data) === null || ref === void 0 ? void 0 : ref.title, " - Senco Gold and Diamonds")
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (slider_module_default()).video_middle,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                        ref: function(el) {
                                                            return videoRefs.current[k] = el;
                                                        },
                                                        src: v.media_url,
                                                        controls: true,
                                                        autoPlay: true,
                                                        muted: true,
                                                        playsInline: true,
                                                        loop: true,
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto",
                                                            opacity: videoLoading ? 0.5 : 1
                                                        },
                                                        onCanPlayThrough: function(e) {
                                                            e.currentTarget.style.background = "none";
                                                        },
                                                        onError: function(e) {
                                                            e.currentTarget.poster = "/fallback.jpg"; // optional
                                                        },
                                                        onCanPlay: function() {
                                                            return setVideoLoading(false);
                                                        }
                                                    })
                                                })
                                            })
                                        }, k);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    onSwiper: setThumbsSwiper,
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                    watchSlidesProgress: true,
                                    className: (slider_module_default()).mySwiper,
                                    children: (0,_to_consumable_array/* default */.Z)(productState.data.medias.map(function(item) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            preview: item.media_type == "video" ? "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/video-play-icon.png" : ""
                                        });
                                    })).map(function(v, k) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            className: "".concat((slider_module_default()).swp, " ", "swp-img"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (slider_module_default()).image_container_det,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: v.media_type == "video" ? v.preview : v.media_url,
                                                    alt: "".concat((ref = productState.data) === null || ref === void 0 ? void 0 : ref.title, " - Senco Gold and Diamonds"),
                                                    unoptimized: true,
                                                    width: 2500,
                                                    height: 2500,
                                                    sizes: "(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px",
                                                    loader: s3_image_loader/* S3ImageLoader */.V
                                                })
                                            })
                                        }, k);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(similar_product/* default */.Z, {
                show: show,
                handleClose: handleClose,
                setIsOpen: setIsOpen,
                isOpen: isOpen,
                image: (ref2 = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.medias[0]) === null || ref2 === void 0 ? void 0 : ref2.media_url,
                skus: skus,
                setskus: setskus
            })
        ]
    });
};
/* harmony default export */ var slider = (ProductDetailsSlider);


/***/ }),

/***/ 61090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_main":"breadcrumb_breadcrumb_main__bykqH","breadcrumb_container":"breadcrumb_breadcrumb_container__FGw7D","separator":"breadcrumb_separator__Td5jS","active":"breadcrumb_active__BR7uS","share_icon":"breadcrumb_share_icon__DZRRk","wish":"breadcrumb_wish__Qa96l","container":"breadcrumb_container__tfg6R"};

/***/ }),

/***/ 41588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mySwiper":"slider_mySwiper__KwHKQ","swiper-slide":"slider_swiper-slide___wLyp","product_slider":"slider_product_slider__6a2gl","best_seller":"slider_best_seller__7qbgC","life_time":"slider_life_time__g0sX7","trending":"slider_trending__v9CKp","popular":"slider_popular__Tl6pC","new_arrival":"slider_new_arrival__E0lEM","discount":"slider_discount__k5DPm","tryontext":"slider_tryontext__gUY94","try__on":"slider_try__on__MMYC8","v_t":"slider_v_t___JUPb","try_container":"slider_try_container__etPcE","try_mobile":"slider_try_mobile__GGaYM","swp":"slider_swp__D4bUu","image_container_det":"slider_image_container_det__9H21t","video_middle":"slider_video_middle__T_7oe"};

/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 75083:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);